import { formatISO } from 'date-fns';
import { useMutation, useQueryClient } from 'react-query';

import { toast } from '@/components/Toaster/Toaster';
import { userApi } from '@/services';

const extractDate = (dueDate) => {
  if (dueDate) {
    const [dd, mm, yy] = dueDate.split('.');

    const day = parseFloat(dd);
    const month = parseFloat(mm) - 1;
    const year = parseFloat(yy);
    return dueDate ? formatISO(new Date(year, month, day)) : null;
  }
  return null;
};

const useMutationCalendar = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'post-date-calendar',
    async ({ dueDate, time, calendarId, status, id = '', title = '', type = '' }) => {
      if (!title) throw new Error('Bitte den Titel eingeben');

      const formatDate = extractDate(dueDate);

      const body = {
        title,
        type: 2,
        date_from: formatDate,
        date_to: formatDate,
        time_from: time || null,
        time_to: time || null,
        status,
        [type === 'task' ? 'fk_task' : 'fk_subtask']: id,
        ...(calendarId ? { id: calendarId } : {}),
      };

      if (dueDate && calendarId) await userApi.put(`/calendar/${calendarId}`, body);
      else if (!dueDate && calendarId) await userApi.delete(`/calendar/${calendarId}`);
      else if (dueDate) await userApi.post('/calendar', body);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('getAppointment');
      },
      onError: (error) => {
        toast({ type: 'error', message: error.message });
      },
    }
  );
};

export default useMutationCalendar;
